import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import CSSTransition from 'react-transition-group/CSSTransition';
import classNames from 'classnames';
import BaseSection from './Base';

// Components
import CurrentProgress from './CurrentProgress';
import ProgressBar from '../ProgressBar';
import { getStep } from '../../utilities/adobeTarget';
import { calculationJourneyAction } from '../../actions/UserData';

class Section extends Component {
  constructor(props) {
    super(props);
    this.onExitingCallback = this.onExitingCallback.bind(this);
    this.trackingClick = this.trackingClick.bind(this);
  }

  onExitingCallback(node) {
    const { error } = this.props;
    // CSS transtition will not finish its cycle on error. Force a reset in that case.
    if (error) {
      node.classList.remove('price-exit');
      node.classList.remove('price-exit-active');
    }
  }

  trackingClick() {
    const { dispatch, userData, activeSectionData } = this.props;
    if (!userData.calculationJourneyStarted && activeSectionData.sectionId === 1) {
      dispatch(calculationJourneyAction());
    }
  }

  render() {
    const {
      actions,
      price,
      loaderProgress,
      currentSectionId,
      finishedSections,
      packageData,
      sectionOrder,
      currentProgress,
      userData,
      activeSectionData,
      currentProgress: {
        hideProgress = false,
        hideCurrentProgress,
      },
      activeSectionData: {
        sectionWidth,
      },
      error,
      errorData,
    } = this.props;
    const stepClass = getStep() || 'step-unknown';
    const sectionClass = classNames(
      stepClass.replaceAll('.', '-'),
      'inner',
      'section__inner', {
        [`inner--${sectionWidth}`]: sectionWidth && !error,
      }
    );
    return (
      /* eslint-disable-next-line */
      <div 
        onClick={() => this.trackingClick()}
      >
        <article className="section">
          <div className={sectionClass}>
            {/* Progress Bar */}
            <CSSTransition
              in={error || !hideProgress}
              timeout={300}
              classNames="fadeIn"
              unmountOnExit
            >
              <aside className="progress">
                <ProgressBar
                  currentProgress={currentProgress}
                  currentSectionId={currentSectionId}
                  finishedSections={finishedSections}
                  packageData={packageData}
                  sectionOrder={sectionOrder}
                />

                {/* Current Progress */}
                <CSSTransition
                  in={!error && !hideCurrentProgress}
                  timeout={300}
                  classNames="fadeIn"
                  unmountOnExit
                >
                  <CurrentProgress currentProgress={currentProgress}/>
                </CSSTransition>
              </aside>
            </CSSTransition>
            <BaseSection
              actions={actions}
              activeSectionData={activeSectionData}
              currentProgress={currentProgress}
              currentSectionId={currentSectionId}
              finishedSections={finishedSections}
              loaderProgress={loaderProgress}
              packageData={packageData}
              price={price}
              userData={userData}
              sectionOrder={sectionOrder}
              error={error}
              errorData={errorData}
            />
          </div>
        </article>
      </div>
    );
  }
}

export default Section;

Section.propTypes = {
  activeSectionData: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  currentProgress: PropTypes.object.isRequired,
  currentSectionId: PropTypes.number.isRequired,
  loaderProgress: PropTypes.number.isRequired,
  finishedSections: PropTypes.array.isRequired,
  packageData: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  sectionOrder: PropTypes.object.isRequired,
  price: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  errorData: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Section/index.jsx